import { Manager } from '../core';

export const get = async () => {
	try {
		const {data} = await Manager.request(
			'get',
			'/admin/user/list.php',
		);
		console.log(`Return ${data}`);
		
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.account.auth', err)
	}
}

export const deleteUser = async (id: number) => {
	try {
		const {data} = await Manager.request(
			'post',
			'/admin/user/delete.php',
			{ id }
		);
		return data;
	} catch (err) {
		throw new Manager.ServiceError('error.customers.deleteUser', err)
	}
}
